import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

// Values map cleanly onto saveOnboardingAnswers' CEFR mapping
// (beginner→A1, elementary→A2, intermediate→B1, advanced/confident→B2).
const answers: AnswerType[] = [
  {
    emoji: '🐣',
    title: 'pages.quizOnboarding.currentLevel.answer1',
    value: 'beginner',
  },
  {
    emoji: '🌱',
    title: 'pages.quizOnboarding.currentLevel.answer2',
    value: 'elementary',
  },
  {
    emoji: '💬',
    title: 'pages.quizOnboarding.currentLevel.answer3',
    value: 'intermediate',
  },
  {
    emoji: '🗣️',
    title: 'pages.quizOnboarding.currentLevel.answer4',
    value: 'advanced',
  },
  {
    emoji: '🚀',
    title: 'pages.quizOnboarding.currentLevel.answer5',
    value: 'confident',
  },
]

export default function CurrentLevelPage() {
  const language = useSelectedLanguageName()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const selectedLevel = event.currentTarget.value as string
    if (selectedLevel) localStorage.setItem('comfortLevel', selectedLevel)
  }

  return (
    <QuizChoicePage
      answers={answers}
      onSubmit={handleSubmit}
      title="pages.quizOnboarding.currentLevel.title"
      translationInterpolation={{ language }}
    />
  )
}
